import ListItem from "@material-ui/core/ListItem";
import classnames from "classnames";
import React from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { usePrevious } from "../../../hooks";
import RideService from "../../../services/ride";
import { set } from "../../../store/actions/currentRide";
import { push } from "../../../store/actions/snackbar";
import { selector } from "../../../store/reducers/currentRide";
import { financeNumberFormat } from "../../../utils/formatters";
import CreditCardImage from "../../CreditCardImage";
import CancelRide from "./CancelRide";
import DriverVehicleCard from "./DriverVehicleCard/DriverVehicleCard";
import { formatDate } from "./helpers";
import RoutePoints from "./RoutePoints";
import styles from "./style.module.css";
import PaymentIcon from "react-payment-icons";
import { RideType, RideTypeMeta } from "../../../constants/rideTypes";

export default React.memo(({ ride, refetchList }) => {
  const isLiveRide = (ride.puTime - Date.now()) < (30 * 60 * 1000) && ![ RideType.CANCELED, RideType.COMPLETED, RideType.NO_SHOW ].includes(ride.status);
  const { data: rideStatus } = useQuery([ "RideStatus", ride.id ], RideService.rideStatus, {
    queryFnParamsFilter: args => args.slice(1),
    refetchInterval: 5 * 1000,
    refetchOnWindowFocus: true,
    enabled: false,//isLiveRide,
  });

  const [ cardRemoved, setCardWasRemoved ] = React.useState(false);
  const [ cardRemoving, setCardRemoving ] = React.useState(false);
  const [ attention, setAttention ] = React.useState(false);
  const dispatch = useDispatch();

  const onCardWasRemoved = React.useMemo(() => (data, error) => {
    if (error?.errorCode === 1501 || data) {
      dispatch(push("Info", `Your ride ${ride.id} was canceled`, "info"));
    }
    refetchList();
    setCardWasRemoved(true);
    dispatch(set());
  }, [ dispatch, refetchList, setCardRemoving ]);

  const selectedRideId = useSelector(state => selector(state)?.ride?.id);
  const lastRideId = useSelector((state) => selector(state)?.lastRideId);
  React.useEffect(() => {
    if (lastRideId === ride.id) {
      dispatch(set(ride));
    }
  }, [ lastRideId ]);

  const puAddress = ride.route?.routePoints?.find(x => x.seqType === "PU");
  const doAddress = ride.route?.routePoints?.find(x => x.seqType === "DO");
  const paymentMethod = ride.paymentMethod;
  const fare = ride.serviceType?.fare;
  const currentRideStatus = rideStatus || ride.status;
  const prevRideStatus = usePrevious(currentRideStatus);
  const rideTypeMeta = RideTypeMeta[currentRideStatus] || RideTypeMeta.UNKNOWN;

  React.useEffect(() => {
    if (prevRideStatus) {
      setAttention(true);
      setTimeout(() => setAttention(false), 3 * 1333);
    }
  }, [ currentRideStatus ]);

  if (cardRemoved) {
    return null;
  }

  return (
    <div className={classnames(styles.root, {
      [styles.removing]: cardRemoving,
      [styles.attention]: attention,
    })}>
      <ListItem className={styles.listItem} selected={ride.id === selectedRideId} onClick={() => dispatch(set(ride))}>
        <div className={styles.item}>
          <div className={styles.baseInfo}>
            <div className={styles.confirmation}>
              #{ride.id.toString()
              .slice(0, -4)}
              <mark>
                {ride.id.toString()
                  .slice(-4)}
              </mark>
            </div>
            <div className={styles.time}>
              {formatDate(new Date(ride.puTime))}
            </div>
            <div className={styles.rideStatus}>
              <i style={{ background: rideTypeMeta.color }} />
              {rideTypeMeta.title}
            </div>
          </div>
          {
            [
              RideType.NEW,
              RideType.ASSIGNED,
              RideType.EN_ROUTE,
              RideType.ON_LOCATION,
            ].includes(ride.status) &&
            <CancelRide
              className={styles.cancel}
              rideId={ride.id}
              setCardRemoving={setCardRemoving}
              onCardRemoved={onCardWasRemoved}
            />
          }
          <RoutePoints puPoint={puAddress} doPoint={doAddress} className={styles.routePoints} />
          {
            isLiveRide && <DriverVehicleCard
              className={styles.driverVehicleCard}
              driver={ride.driver}
              vehicle={ride.vehicle} />
          }
          <div className={styles.card}>
            {
              paymentMethod.paymentType === "CARD" &&

              <CreditCardImage className={styles.card} cardType={paymentMethod.bankCardType} />
            }
            <span>{paymentMethod.name}</span>
          </div>
          <span className={styles.rate}>${financeNumberFormat(fare.baseRate)}</span>
        </div>
      </ListItem>
    </div>
  );
});
